import NoDataFound from "./no-data.svg";
import ChakravyuhLogo from "./gotiloLogo.png";

export { NoDataFound, ChakravyuhLogo };
